<script>
    import R from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../icons/AppIcon.svelte";
    import ControlLoader from "../ControlLoader.svelte";

    export let vehicle_id = null;

    export let transporter_id = null;
    export let index = null;
    export let id = "vehicleControl";
    export let placeholder = 'find vehicle';

    let vehicle = null;
    let term = '';
    let vehicleInfo = null;
    let results = [];
    let listIndex = -1;
    let timer;
    let showDropdown = false;
    let showNotFound = false;
    let loading = false;

    const dispatch = createEventDispatcher();

    const clear = () => {
        showDropdown = false;
        showNotFound = false;
        results = [];
        listIndex = -1;
        vehicle_id = null;
        vehicle = null;
        vehicleInfo = null;
        term = '';
        dispatch("change");
    }

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onNameKeydown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter' && listIndex > -1) {
                event.preventDefault();
                selectResult(results[listIndex]);
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    // const onNameKeyup = (event) => {
    //     if (term !== event.target.value && event.target.value.length) {
    //         term = event.target.value;
    //         if (timer) {
    //             clearInterval(timer);
    //         }
    //         timer = setInterval(() => {
    //             clearInterval(timer);
    //             search();
    //         }, 300);
    //     }
    // }

    const onNameKeyup = (event) => {
        if (term != event.target.value) {
            showNotFound = false;
            term = event.target.value;
            if (timer) {
                clearInterval(timer);
            }

            if (term.length) {
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                clear();
            }
        }
    }

    const selectResult = (item) => {
        vehicle_id = item.id;
        vehicle = item;
        term = item.licence_no;
        if (index != null) {
            dispatch('change', {index, vehicle: item});
        } else {
            dispatch('change', item);
        }
        closeDropdown();
    }

    const search = () => {
        const onSuccess = result => {
            results = result;
            showNotFound = results.length === 0;
            loading = false;
            openDropdown();
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;
        R.handle(R.vehicle.search, {name: term, transporter_id}, onSuccess, onFailure);
    }

    const openDropdown = () => {
        if (!showDropdown) {
            showDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeDropdown = () => {
        if (showDropdown) {
            showDropdown = false;
            results = [];
            listIndex = -1;
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }

    const initialize = () => {
        if (!vehicle_id) {
            return;
        }

        const onSuccess = result => {
            vehicle = result;
            term = vehicle.licence_no;
            loading = false;
        }

        const onFailure = err => {
            loading = false;
        };

        loading = true;
        R.handle(R.vehicle.details, vehicle_id, onSuccess, onFailure);
    }

    initialize();

    $: {
        if (vehicle_id != null && vehicle_id > 0 && !vehicle) {
            initialize();
        } else if (vehicle_id == null && vehicle) {
            vehicle = null;
            term = '';
        }

        if (vehicle) {
            vehicleInfo = (vehicle.transporter_name ? vehicle.transporter_name + ' | ' : '') + vehicle.type.name;
        } else {
            vehicleInfo = null;
        }
    }
</script>

<div class="dropdown-container vehicle-control" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="content">
        <input type="text" class="form-control" {id} value="{ term }"
               on:keydown="{ onNameKeydown }"
               on:keyup="{ onNameKeyup }"
               {placeholder}
               autocomplete="off">
        {#if vehicleInfo}
            <div class="info">{ vehicleInfo }</div>
        {/if}
        {#if showNotFound}
            <div class="not-found">
                <AppIcon icon="circle-exclamation-solid" size="16"/>
            </div>
        {/if}
        <ControlLoader {loading}/>
    </div>
    {#if showDropdown && results.length}
        <ul class="dropdown">
            {#each results as item, index}
                <li class="dropdown-item vehicle-item" class:selected="{ listIndex === index }"
                    on:click="{ () => selectResult(item) }">
                    { item.licence_no }
                    <div class="info">
                        { item.transporter_name } | { item.type.name }
                    </div>
                </li>
            {/each}
        </ul>
    {/if}
</div>

<style>
    .content {
        position: relative;
    }

    .content .info {
        position: absolute;
        left: 8px;
        bottom: -6px;
        font-size: 10px;
        color: #999;
        background: #fff;
        padding: 0 5px;
    }

    .vehicle-control .dropdown {
        max-height: 340px;
        overflow-y: auto;
    }

    .vehicle-item {
        cursor: pointer;
    }

    .vehicle-item .info {
        font-size: 10px;
        color: #999;
    }

    .not-found {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        color: rgba(255, 0, 0, 0.5);
    }
</style>